export default {
  name: 'color-picker',
  label: '颜色选取',
  icon: 'el-icon-edit',
  config: [],
  hidden: true
};